import Axios from "axios";
import { SET_PROMOTION_LIST, UNSET_PROMOTION_LIST } from "@/store/mutation-types";
import {
    getPromotionList,
    getPromotionById,
    saveOrUpdatePromotion,
    updatePromotion,
    deletePromotion,
    generatePromotionReferenceNumber,
} from "@/store/api";

// initial state
const state = {
    getHrmPromotionList: [],
    editingPromotion: null,
}

const getters = {
    getHrmPromotionList(state){
        return state.getHrmPromotionList;
    },
    getEditingPromotion: (state) => { 
        return state.editingPromotion;
    },
}

const mutations = {
    [SET_PROMOTION_LIST](state, data) {
        state.getHrmPromotionList = data;
    },
    [UNSET_PROMOTION_LIST](state) {
        state.getHrmPromotionList = [];
    },
    setEditingPromotion(state, promotion) {
        state.editingPromotion = promotion;
    },
    clearEditingPromotion(state) {
        state.editingPromotion = null;
    }
}

const actions = {
    getPromotionList({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
            Axios.get(getPromotionList, { params })
                .then((response) => {
                    commit(SET_PROMOTION_LIST, response.data.data || []);
                    resolve(response.data);
                })
                .catch((error) => {
                    commit(UNSET_PROMOTION_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING", null, { root: true });
                });
        });
    },

    getPromotionById({ commit }, id) {
        return new Promise((resolve, reject) => {
            Axios.get(getPromotionById(id))
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING", null, { root: true });
                });
        });
    },

    saveOrUpdatePromotion({ commit }, promotionData) {
        return new Promise((resolve, reject) => {
            Axios.post(saveOrUpdatePromotion, promotionData)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING", null, { root: true });
                });
        });
    },

    updatePromotion({ commit }, { id, promotionData }) {
        return new Promise((resolve, reject) => {
            Axios.put(updatePromotion(id), promotionData)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING", null, { root: true });
                });
        });
    },

    generatePromotionReferenceNumber({ commit }) {
        return new Promise((resolve, reject) => {
            Axios.get(generatePromotionReferenceNumber)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING", null, { root: true });
                });
        });
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
